import React from 'react'
import SelectField from 'material-ui-legacy/SelectField'
import MenuItem from 'material-ui-legacy/MenuItem'

const FormulaTypeSelect = (props) => (
  <SelectField
    name='formulaType'
    floatingLabelText={props.floatingLabelText}
    fullWidth={props.fullWidth || true}
    style={props.style}
    value={props.value}
    onChange={props.onChange}
    required={props.required}
  >
  	{props.showAllFormulas &&
	    <MenuItem
	      value=''
	      primaryText='All formulas'
	    />
  	}
    <MenuItem
      value='cost'
      primaryText='Cost formula'
    />
    <MenuItem
      value='rate'
      primaryText='Rate formula'
    />
  </SelectField>
)

export default FormulaTypeSelect


// WEBPACK FOOTER //
// ./src/components/Formulas/FormulaTypeSelect.jsx